<template>
  <div>
    <el-dialog
      title="设置CRM帐号"
      :visible.sync="visible"
      width="33 %"
      :before-close="handleClose"
      :closeOnPressEscape="false"
    >
      <el-alert
        :closable="false"
        description="使用下方的【CRM帐号】和【CRM密码】即可登陆"
      >
        <div slot="title">
          <span @click="goCrmUrl" class="goLink">点击跳转访问CRM系统</span>
          <el-divider direction="vertical"></el-divider>
          <span @click="goCrmAppUrl" class="goLink">点击下载CRM-APP</span>
        </div>
      </el-alert>
      <br />
      <el-divider content-position="left">CRM账号设置</el-divider>
      <el-form
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="120px"
      >
        <el-form-item label="CRM帐号" prop="UserName">
          <el-input
            v-model="dataForm.UserName"
            :disabled="disabled"
            placeholder="请输入CRM帐号"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="CRM密码" prop="Password">
          <el-input
            v-model="dataForm.Password"
            placeholder="请输入CRM密码"
            size="medium"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <!-- <el-button @click="handleClose">关闭</el-button> -->
        <el-button
          type="primary"
          :loading="confirmLoading"
          @click="ok"
          v-if="!disabled"
          v-permission="['/api/CRM/CreateUser']"
          >确认设置</el-button
        >
        <el-button
          v-else
          type="primary"
          :loading="confirmLoading"
          @click="okset"
          v-permission="['/api/CRM/ResetPassword']"
          >重置密码</el-button
        >
        <!-- /api/CRM/ResetPassword -->
      </div>
      <br />
      <br />
      <el-divider content-position="left">CRM账号数量上限设置</el-divider>
      <br />
      <el-form
        label-width="120px"
        ref="dataForm2"
        :model="dataForm2"
        :rules="rules2"
      >
        <el-form-item label="CRM账号上限" prop="LimitedCount">
          <el-input
            v-model="dataForm2.LimitedCount"
            placeholder="请输入CRM账号上限"
            type="number"
          >
            <div slot="suffix" style="margin-right: 10px">
              <el-tooltip
                effect="dark"
                content="设置上限的数量代表最大只能开设的CRM帐号数量"
                placement="top"
              >
                <i class="el-icon-question" style="font-size: 20px"></i>
              </el-tooltip>
            </div>
          </el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button
          type="primary"
          v-permission="['/api/CRM/SetUserCount']"
          :loading="confirmNumberLoading"
          @click="editNumber"
          >修改上限个数</el-button
        >
      </div>
      <br />
    </el-dialog>
  </div>
</template>

<script>
import TenantCustomersSelectVue from "@/components/TenantCustomersSelect.vue";
let passwordRegex = /^(?=.*[0-9])(?=.*[a-zA-Z]).{8,}$/;
export default {
  components: { TenantCustomersSelectVue },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入CRM密码"));
      } else if (!passwordRegex.test(value)) {
        callback(new Error("密码需要包含数字和字母，且长度至少为8个字符"));
      } else {
        callback();
      }
    };
    return {
      visible: false,
      confirmLoading: false,
      confirmNumberLoading: false,
      disabled: false,
      dataForm: {
        CompanyId: "",
        UserId: "",
        UserName: "",
        Password: "",
      },
      dataForm2: {
        CompanyId: "",
        LimitedCount: "0",
      },
      rules: {
        UserName: [
          {
            required: true,
            message: "请输入名称CRM帐号",
            trigger: "blur",
          },
          {
            min: 8,
            max: 20,
            message: "长度在 8 到 20 个字符",
            trigger: "change",
          },
        ],
        Password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",
          },
        ],
      },
      rules2: {
        LimitedCount: {
          required: true,
          message: "请输入上限数量",
          trigger: "blur",
        },
      },
      CrmAppUrl: "",
      CrmUrl: "",
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      if (id) {
        this.dataForm.CompanyId = id;
        this.dataForm2.CompanyId = id;
        this.$http({
          url: "/api/CRM/User?companyId=" + id,
          method: "get",
        }).then((res) => {
          this.CrmAppUrl = res.data.response.CrmAppUrl;
          this.CrmUrl = res.data.response.CrmUrl;
          if (!!res.data.response.UserName) {
            this.disabled = true;
            this.dataForm.UserName = res.data.response.UserName;
            this.dataForm.UserId = res.data.response.UserId;
          } else {
            this.disabled = false;
          }
          this.dataForm2.LimitedCount = res.data.response.LimitedCount || 0;
        });
      }
    },
    handleClose() {
      this.$refs.dataForm.resetFields();
      this.$refs.dataForm2.resetFields();
      this.visible = false;
      setTimeout(() => {
        this.disabled = false;
      }, 500);
    },
    goCrmUrl() {
      if (!this.CrmUrl) return this.$message.error("crm域名未配置");
      window.open(this.CrmUrl);
    },
    goCrmAppUrl() {
      if (!this.goCrmAppUrl) return this.$message.error("crm域名未配置");
      window.open(this.CrmAppUrl);
    },
    ok() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: "/api/CRM/CreateUser",
            method: "post",
            data: this.dataForm,
          })
            .then((res) => {
              if (res.data && res.data.success) {
                this.confirmLoading = false;
                console.log(res);
                this.$message.success(res.data.msg || "设置成功");
                this.handleClose();
                this.$emit("ok");
              }
            })
            .finally(() => (this.confirmLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //重置CRM密码
    okset() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: "/api/CRM/ResetPassword",
            method: "put",
            data: this.dataForm,
          })
            .then((res) => {
              if (res.data && res.data.success) {
                this.confirmLoading = false;
                console.log(res);
                this.$message.success(res.data.msg || "设置成功");
                this.handleClose();
                this.$emit("ok");
              }
            })
            .finally(() => (this.confirmLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //修改个数
    editNumber() {
      this.$refs.dataForm2.validate((valid) => {
        if (valid) {
          this.confirmNumberLoading = true;
          this.$http({
            url: "/api/CRM/SetUserCount",
            method: "put",
            data: this.dataForm2,
          })
            .then((res) => {
              if (res.data && res.data.success) {
                this.confirmNumberLoading = false;
                console.log(res);
                this.$message.success(res.data.msg || "设置上限数量成功");
                this.handleClose();
                this.$emit("ok");
              }
            })
            .finally(() => (this.confirmNumberLoading = false));
        }
      });
    },
  },
};
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
input[type="number"] {
  -moz-appearance: textfield;
}

.goLink {
  cursor: pointer;
}
</style>